import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { consumidoresApi } from '@/services/consumidores';
import type { ConsumidorCreate, ConsumidorUpdate } from '@/types/consumidores';

export const consumidoresKeys = {
  all: ['config', 'consumidores'] as const,
  uso: (id: string) => ['config', 'consumidores', id, 'uso'] as const,
};

export function useConsumidores() {
  return useQuery({ queryKey: consumidoresKeys.all, queryFn: consumidoresApi.list });
}
export function useConsumidorUso(id: string | null) {
  return useQuery({
    queryKey: consumidoresKeys.uso(id ?? ''),
    queryFn: async () => {
      if (!id) throw new Error('id is required');
      return consumidoresApi.usage(id);
    },
    enabled: !!id,
  });
}
export function useCreateConsumidor() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (p: ConsumidorCreate) => consumidoresApi.create(p),
    onSuccess: () => qc.invalidateQueries({ queryKey: consumidoresKeys.all }),
  });
}
export function useUpdateConsumidor() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, payload }: { id: string; payload: ConsumidorUpdate }) =>
      consumidoresApi.update(id, payload),
    onSuccess: () => qc.invalidateQueries({ queryKey: consumidoresKeys.all }),
  });
}
export function useRevokeConsumidor() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => consumidoresApi.revoke(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: consumidoresKeys.all }),
  });
}
